import LegalPageLayout from "@/components/LegalPageLayout";

export default function Refund() {
  return (
    <LegalPageLayout
      title="Refund Policy"
      description="Refund terms for services offered through College Unlock."
      updated="June 2026"
      testid="refund-page"
    >
      <p>
        This Refund Policy applies to payments made for services offered through College Unlock.
      </p>

      <h2>Paid Services & Refunds</h2>
      <p>
        Where paid services are offered, refund eligibility and timelines will be communicated at the
        time of purchase. Approved refunds are processed to the original payment method.
      </p>

      <h2>Payment Processing</h2>
      <p data-testid="refund-ownership">
        Payments made through College Unlock are processed by the legal operating entity: Spiritual
        Mantra.
      </p>

      <h2>Contact</h2>
      <p>
        For any refund-related queries, please reach us at hello@collegeunlock.in.
      </p>
    </LegalPageLayout>
  );
}
